import React, { memo, useState } from 'react';
import './CartModal.scss';
import PropTypes from 'prop-types';
import Modal from '@components/feedback/Modal/Modal';
import { connect, useDispatch } from 'react-redux';
import mova from 'mova';
import DishCard from '@components/display/DishCard/DishCard';
import Button from '@components/inputs/Button/Button';
import { closeModal } from '@store/actions/modal.js';
import { calculateTotalOrderPrice, getPlaceOrders } from '@utils/menu/menu';
import currency from '@filters/currency';
import Checkbox from '../../../components/inputs/Checkbox/Checkbox';
import TextArea from '../../../components/inputs/TextArea/TextArea';
import Form from '../../../components/inputs/Form/Form';
import { placeOrder } from '../../../../data/store/actions/menu';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { getPaymentLink } from '@actions/billing';

const t = mova.ns('containers.CartModal');

const CartModal = ({ location, place, placeOrder }) => {
  const dispatch = useDispatch();
  const [addComment, setAddComment] = useState(false);
  const placeOrders = getPlaceOrders();
  const queryParams = queryString.parse(location.search);
  const isOrderActive = queryParams.spot_id && place.clientOrdersActive;
  const dishes = place?.dishes || [];
  const dishCards = placeOrders.map(o =>
    <DishCard
      key={o.id}
      order={o}
      dish={dishes.find((d) => d.id === o.id)}
      placeOrders={placeOrders}
      short
    />
  );
  const totalOrderPrice = calculateTotalOrderPrice()
  const handleOder = (data) => {
    placeOrder({ orderDishes: placeOrders, comment: data.comment, spotId: Number(queryParams.spot_id) });
  }

  return (
    <Modal className='cart-modal' title={t('title')}>
      {dishCards.length === 0 && <div className='cart-modal__empty'>{t('empty')}</div>}
      {dishCards.length > 0 && (
        <div>
          {dishCards}
          <div className='cart-modal__total'>
            <div>{t('total')}:</div>
            <div>{currency(totalOrderPrice)}</div>
          </div>
          {isOrderActive && (
            <Form onValidSubmit={handleOder}>
              <div className='cart-modal__checkbox'>
                <Checkbox name='addComment' onClick={() => setAddComment(!addComment)}>
                  {t('addComment')}
                </Checkbox>
              </div>
              {addComment && (
                <TextArea className='cart-modal__comment' name='comment' placeholder={t('comment')} fullWidth />
              )}
              <div className='cart-modal__button-wrapper'>
                <Button inputClass='cart-modal__close-button' onClick={() => dispatch(closeModal())}>
                  {t('back')}
                </Button>
                <Button behavior='submit' inputClass='cart-modal__submit-button'>
                  {t('order')}
                </Button>
              </div>
            </Form>
          )}
        </div>
      )}
    </Modal>
  );
};

CartModal.propTypes = {
  place: PropTypes.object.isRequired,
};

const mapStateToProps = ({ place }) => ({
  place: place.details.data,
  orders: place.menu, // to refresh in case of changes
});

const mapDispatchToProps = {
  placeOrder,
  getPaymentLink,
};

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(CartModal)));
